// Zotte Zomer Ronse 2026 — Partner formules (zichtbaarheidspakketten)
// CRITICAL: NO PRICES, NO AMOUNTS, NO FINANCIAL FIGURES.
// Each formula lists ZICHTBAARHEIDS-BENEFITS only.

export const PARTNER_FORMULAS = [
    {
        id: 'zomerkick',
        name: 'ZOMERKICK',
        tagline: 'Premium partner',
        meta: 'Exclusief · max 3 partners',
        accent: 'cream',
        premium: true,
        intro: 'Voor partners die hét gezicht van Zotte Zomer willen zijn. Maximale zichtbaarheid, een eigen verhaal en exclusieve VIP-beleving.',
        benefits: [
            'Maximale zichtbaarheid tijdens de 3 festivaldagen',
            'Groot logo op LED-schermen, podium en Promocampagne',
            'Vertoning van eigen filmpje en gepersonaliseerde jingle tussen de acts',
            'Uitgebreide activatiemogelijkheden',
            'Zichtbaar op aftermovie en socials van Stad Ronse & Ronse Leeft',
            'Gepersonaliseerde Cocktail op de kaart',
            'Premium VIP-beleving voor jouw genodigden',
        ],
        vipNote: 'Premium VIP-beleving',
    },
    {
        id: 'zomerboost',
        name: 'ZOMERBOOST',
        tagline: 'Headline partner',
        meta: 'Sterke zichtbaarheid',
        accent: 'mint',
        premium: false,
        intro: 'Voor partners die volop mee in beeld willen, op affiche, online en op het festivalterrein.',
        benefits: [
            'Sterke zichtbaarheid tijdens de 3 festivaldagen',
            'Logo op LED-schermen, podiumomkadering, bartent en T-shirts',
            'Zichtbaar op aftermovie en socials van Stad Ronse & Ronse Leeft',
            'Mogelijkheid tot activatie op het terrein',
            'Ruime VIP-beleving voor jouw team en gasten',
        ],
        vipNote: 'Ruime VIP-beleving',
    },
    {
        id: 'zomervibes',
        name: 'ZOMERVIBES',
        tagline: 'Beleving partner',
        meta: 'Mee in de sfeer',
        accent: 'pink',
        premium: false,
        intro: 'Voor partners die graag deel uitmaken van de festivalsfeer met een mooie zichtbaarheid online en op het terrein.',
        benefits: [
            'Zichtbaarheid tijdens de 3 festivaldagen',
            'Logo op LED-schermen, podiumomkaderingen en T-shirts',
            'Logo op website & regionale krant',
            'Uitgebreide VIP-beleving voor jouw genodigden',
        ],
        vipNote: 'Uitgebreide VIP-beleving',
    },
    {
        id: 'zomergoesting',
        name: 'ZOMERGOESTING',
        tagline: 'Sfeer-partner',
        meta: 'Kennismaking',
        accent: 'yellow',
        premium: false,
        intro: 'De toegankelijke instap voor lokale ondernemers die mee de zomer willen kleuren.',
        benefits: [
            'Instapformule voor lokale zichtbaarheid',
            'Vermelding op website en social media',
            'Mogelijkheid om uw merk aanwezig te maken op het festival',
            'VIP-beleving voor jou en je gast',
        ],
        vipNote: 'VIP-beleving inbegrepen',
    },
];
